import * as React from 'react';
import Anchor from '@telia-front/anchor';
import Button from '@telia-front/button';
import Grid, { GridColumn } from '@telia-front/grid';
import Image from '@telia-front/image';
import Text from '@telia-front/text';
export default class Product extends React.Component {
    BEM() {
        const classArray = ['product'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    render() {
        return (React.createElement(Grid, { align: ['center-lg'], className: this.BEM() },
            React.createElement(GridColumn, { className: "product__image", width: ['lg-12', 'xs-3'], align: ['top-xs'] },
                React.createElement(Anchor, Object.assign({}, this.props.anchor),
                    React.createElement(Image, Object.assign({ align: "center" }, this.props.image)))),
            React.createElement(GridColumn, { className: "product__content", align: ['middle-xs'], width: ['lg-12', 'xs-9'] },
                React.createElement(Grid, { align: ['center-lg', 'between-xs', 'middle-xs'] },
                    React.createElement(GridColumn, { width: ['lg-12', 'xs'] },
                        React.createElement(Text, { className: "product__text" }, this.props.children)),
                    React.createElement(GridColumn, { className: "product__action", width: ['lg-12', 'xs'] },
                        React.createElement(Button, Object.assign({ className: "product__button" }, this.props.button)))))));
    }
}
